import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/venue/venueApply/payPage', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/venue/venueApply/payDetail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/venue/serviceConfig/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/venue/serviceConfig/submit', params,options)

export const update = (params, options) =>
request.post('/api/venue/serviceConfig/update', params,options)

export const getAreaList = (params, options) =>
request.get('/api/venue/area/loadArea', Object.assign({}, options, { params }));

export const getVenueNameList = (params, options) =>
request.get('/api/venue/manage/getName', Object.assign({}, options, { params }));

export const getVenueTypeList = (params, options) =>
request.get('/api/blade-system/dict/dictionaryWithIntKey?code=venue_type', Object.assign({}, options, { params }));

export const getVenueChargeTypeList = (params, options) =>
request.get('/api/blade-system/dict/dictionaryWithIntKey?code=venue_charge_type', Object.assign({}, options, { params }));

export const auditChangeStatus = (params, options) =>
request.get('/api/v4ward/venue/venueApply/changeStatus', Object.assign({}, options, { params }));


export const pay = (params, options) =>
request.get('/api/v4ward/venue/venueApply/payMoney', Object.assign({}, options, { params }));

export const getApplyStatusList = (params, options) =>
request.get('/api/blade-system/dict/dictionaryWithIntKey?code=venue_apply_status', Object.assign({}, options, { params }));


